import React from 'react';
import Chart from 'react-apexcharts';
import { formatCash } from '../../../../utils/tableHelpers';
import Styles from './RewardPieChart.module.scss';

interface IRewardPieChart{
  payload:any;
}
const RewardPieChart = ({ payload }:IRewardPieChart) => {
  const details = {
    options: {
      legend: {
        show: false,
      },
      colors: ['black', '#170063'],
      labels: ['Amount paid', 'Amount withdrawn'],
      dataLabels: {
        enabled: false,
        formatter(val) {
          return `$${formatCash(val)}`;
        },
      },

    },
    series: [payload?.totalAmountPaid || 0, payload?.totalAmountWithdrawn || 0],
    labels: ['Amount paid', 'Amount withdrawn'],

  };
  return (
    <div>
      <div className={Styles.wrapper}>
        <div className={Styles.wrapper__labelContainer}>
          <div className={Styles.wrapper__value}>{payload?.totalReferral || 0}</div>
          <div className={Styles.wrapper__title}>referrals</div>
        </div>
        <Chart options={details?.options} series={details?.series} type="donut" width={220} height={250} />
      </div>
    </div>
  );
};

export default RewardPieChart;
